// opervex-frontend/src/Opervex/Report/SalesOrder.js

class SalesOrder {
  #api;

  constructor(api) {
    this.#api = api;
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "documentDate",
        label: "Data do documento",
        type: "date",
        visible: true,
        hidden: false,
      },
      {
        key: "customerName",
        label: "Nome Cliente",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "protocol",
        label: "Protocolo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "serviceId",
        label: "Código Serviço",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "serviceText",
        label: "Texto do Serviço",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "planPrice",
        label: "Valor do Plano",
        type: "currency",
        visible: true,
        hidden: false,
      },
      {
        key: "newPrice",
        label: "Valor Novo",
        type: "currency",
        visible: true,
        hidden: false,
      },
      {
        key: "sellerId",
        label: "Código Vendedor",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "sellerName",
        label: "Nome do Vendedor",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "mobileLines",
        label: "Linhas Móveis",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "operatorId",
        label: "Código Operadora",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "operatorText",
        label: "Nome da Operadora",
        type: "string",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default SalesOrder;
